//import the react and ReactDOM libraries
import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';



// Take the react component and show it on the screen

    ReactDOM.render(<App /> , document.querySelector('#root'));
